import { render, staticRenderFns } from "./DashLoader.vue?vue&type=template&id=eed84462&"
import script from "./DashLoader.vue?vue&type=script&lang=js&"
export * from "./DashLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports